/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/number/ToUint8Array.ts
 * @create:      2025-06-27 10:43:28.150
 * @modify:      2025-07-11 21:19:12.806
 * @version:     6.0.0
 * @times:       7
 * @lines:       55
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { SplitByN } from "../string/SplitByN";
import { ToHex } from "./ToHex";

/**
 * Converts a number to a Uint8Array representation.
 *
 * This function first converts the input number to its hexadecimal string representation,
 * splits the hex string into pairs of characters (bytes), parses each pair as a base-16 integer,
 * and returns a Uint8Array containing the resulting byte values.
 *
 * @param number - The number to convert to a Uint8Array.
 * @returns A Uint8Array representing the byte sequence of the input number.
 * 
 * @since 1.0.5
 * @version 2025-06-21
 */
export function ToUint8Array(number: number) {
    const hex = ToHex(number);
    const hexArray = SplitByN(hex, 2).map(p => parseInt(p, 16));
    const result = new Uint8Array(hexArray);
    return result;
}
